import { Offer } from './Offer'

export enum Interval {
  ONCE = 'ONCE',
  MONTHLY = 'MONTHLY',
}

export type OfferEntry = {
  uuid?: string

  offerUUID?: string
  arbeitspaketUUID?: string
  amount?: number
  scheduledDate?: Date
  interval: Interval
  // only used if interval is MONTHLY
  monthAmount?: number

  accepted?: boolean

  // dynamic properties
  offer?: Offer
}
